import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {typeSeasonService} from "../../../jwt/_services/clasificator/typeSeasonService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function TypeSeasonForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            name: savedData?.name,
            code: savedData?.code
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);

        let dataRequest = { ...data };

        if (!editMode) {
            //Save
            return typeSeasonService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;

            if (JSON.stringify(savedData) === JSON.stringify(dataRequest))
                return showToastCustom(info, infoMsg);

            dataRequest = { ...dataRequest, id }

            return typeSeasonService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setForm = () => {
        props.setForm();
    }

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="text" name="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Código</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder="Código"
                                    innerRef={register}
                                    disabled={disableInputs}
                                    className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="text" name="name"
                                       placeholder="Ingrese Nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}